const removeHtmlTags = (html: string) => html.replace(/(<([^>]+)>)/gi, "");
export default removeHtmlTags;
